import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { useBug } from "./Hook";
import { CgDanger } from "react-icons/cg";
import { formatMuiErrorMessage } from "@mui/utils";
import toast from "react-hot-toast";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import supImg from '../../../App/assets/images/call-center 1.png';
import { AiOutlineClose } from "react-icons/ai";

const style = {
  position: "absolute",
  bottom: "10px",
  right: "10px",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "white",
  padding: "10px",
  borderRadius: "10px",
  maxWidth: "300px",
};
export default function BasicModal({ isApp }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [validate, setValidate] = useState([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { user } = useSelector(state => state);
  const { form, setForm, loading, sendBug } = useBug();
  const isIn = key => {
    let res = false;
    [...validate].map(item => {
      if (item.key == key) {
        res = key;
      }
    });
    return res;
  };
  const handlerSendbug = () => {
    let check = [];
    Object.keys(form).map(data => {
      if (!form[data]) check = [...check, { message: "", key: data }];
    });
    if (check.length == 0) {
      sendBug({ path: location.pathname }).then(handleClose());
    } else {
      setValidate(check);
    }
  };
  return (
    <div>
      <Button
        onClick={handleOpen}
        style={{
          position: "fixed",
          bottom: isApp ? "70px" : "10px",
          right: isApp ? "auto" : "10px",
          left: isApp && "0",
          padding: "0px",
        }}
        title={"گزارش اشکال"}
      >
        {isApp
          ? <img src={supImg} />
          : <CgDanger style={{ color: "red", fontSize: "40px", padding: "0px" }} />
        }
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={{ ...style }} dir="rtl">
          {isApp &&
            <div className="text-left" onClick={e => handleClose()}>
              <AiOutlineClose />
            </div>
          }
          <div className="text-center jus">
            <h5>گزارش اشکال در سامانه</h5>
            <span
              style={{
                fontSize: "10px",
                fontWeight: "400",
                inlineSize: "280px",
                overflowWrap: "break-word",
              }}
            >
              گزارش شما مستقیم به تیم فنی ارجاع داده شده و در اسرع وقت پیگیری
              خواهد شد
            </span>
          </div>
          <div style={{}} className="mt-1">
            <label
              htmlFor="name"
              className="mb-1"
              style={{
                fontWeight: "400",
              }}
            >
              نام شما :
            </label>
            <input
              type="text"
              id="name"
              className="w-100 form-control"
              onChange={e => {
                setForm({ ...form, fullname: e.target.value });
                setValidate([
                  ...validate.filter(item => item.key !== "fullname"),
                ]);
              }}
              value={user && user.fullname}
              style={{
                border: isIn("fullname")
                  ? "1px solid red"
                  : "1px solid #ced4da",
              }}
            />
          </div>
          <div style={{}} className="mt-1">
            <label
              htmlFor="name"
              className="mb-1"
              style={{
                fontWeight: "400",
              }}
            >
              {" "}
              شماره همراه :
            </label>
            <input
              type="text"
              id="name"
              className="w-100 form-control"
              onChange={e => {
                setForm({ ...form, mobile: e.target.value });
                setValidate([
                  ...validate.filter(item => item.key !== "mobile"),
                ]);
              }}
              value={user && user.mobile}
              style={{
                border: isIn("mobile") ? "1px solid red" : "1px solid #ced4da",
              }}
            />
          </div>
          <div style={{}} className="mt-1">
            <label
              htmlFor="title"
              className="mb-1"
              style={{
                fontWeight: "400",
              }}
            >
              {" "}
              عنوان اشکال :
            </label>
            <input
              type="text"
              id="title"
              className="w-100 form-control"
              onChange={e => {
                setForm({ ...form, title: e.target.value });
                setValidate([...validate.filter(item => item.key !== "title")]);
              }}
              style={{
                border: isIn("title") ? "1px solid red" : "1px solid #ced4da",
              }}
            />
          </div>
          <div style={{}} className="mt-1">
            <label
              htmlFor="tell"
              className="mb-1"
              style={{
                fontWeight: "400",
              }}
            >
              {" "}
              متن گزارش :
            </label>
            <textarea
              type="text"
              id="name"
              className="w-100 form-control"
              onChange={e => {
                setForm({ ...form, message: e.target.value });
                setValidate([
                  ...validate.filter(item => item.key !== "message"),
                ]);
              }}
              style={{
                border: isIn("message") ? "1px solid red" : "1px solid #ced4da",
                resize: "none",
                height: "20vh",
              }}
            />
          </div>
          <div style={{}} className="mt-2">
            <button
              className="btn  bg-success w-100"
              style={{ color: "white" }}
              onClick={() => {
                handlerSendbug();
              }}
            >
              {loading ? "در حال ارسال" : "ثبت گزارش"}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
